import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import CustomButton from "../CustomButton";
import CustomDropzone from "../CustomDropzone";
import dz from "../../assets/drop_your_file.png";
import { showToast } from "../../utils/toastUtils";
import styles from "./FileUpload.module.css";

//InitUrl is the url pass to the dropzone to upload files

function FileUploadModal({ show, handleClose, initUrl,refreshFiles}) {
  const [uploadData, setUploadData] = useState(null);
 
  const handleUpload = () => {
    if (!uploadData) {
      showToast("Please select a file first!", "warning");
      return;
    }

    refreshFiles();
    handleClose();
    showToast("File uploaded successfully", "success");

    // Reset the file input
    setUploadData(null);
  };

  return (
    <Modal show={show} onHide={handleClose} className={`${styles.cdz} `}>
      <Modal.Header closeButton  style={{ borderBottom: 0 ,padding:22}} />
      <Modal.Body  style={{ margin: "auto",padding: "0px"}}>
        {/* Dropzone for Upload */}
        <CustomDropzone
          className={`${styles.dropzone} d-flex justify-content-center`}
          setUploadData={setUploadData}
          initUrl={initUrl}
          method="POST"
          acceptedFiles="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/csv, image/jpeg, image/png, image/gif, application/zip, audio/mpeg, video/mp4, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        >
          <img src={dz} alt="Drop your file here" className={styles.innerImage} />
        </CustomDropzone>

        <Modal.Footer className="justify-content-center border-0 pt-4 pb-5">
          <CustomButton onClick={handleUpload}>Upload</CustomButton>
          
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
}

export default FileUploadModal;
